import React, { useEffect, useState } from 'react';
import { Icon, AnchorButton, Tag } from '@blueprintjs/core';
import './network-topology-cluster-expansion.scss';
import AFIcon from 'assets/topology/AF_Network_Element.svg';
import CFIcon from 'assets/topology/CF_Network_Element.svg';
import XCluster from 'assets/topology/Xcipio_Cluster.svg';
import { Tooltip2 } from '@blueprintjs/popover2';
import { width } from '@material-ui/system';

type Props = {
    setClusterExpansionList: any,
    clusterExpansionList: any,
    onFilterPoi: (poi: { id: string, type: string }) => void,
    onCloseSideMenu: () => void,
}

const NetworkTopologyClusterExpansionPane = ({
    setClusterExpansionList,
    clusterExpansionList,
    onFilterPoi,
    onCloseSideMenu,
}: Props) => {
    const [prefixFilter, setprefixFilter] = useState<string>('');
    const [selectedNetworkElement, setSelectedNetworkElement] = useState<string>('');
    const handleSelectPoi = (element: any) => () => {
      const type = element?.options?.['data-original'].type;
      const id = element?.options?.['data-original']?.data?.id;

      if (id == null || type == null) {
        return;
      }
      onFilterPoi({ id, type });
      setSelectedNetworkElement(element.options['data-original'].data.id)
    }

    const handleCloseSideMenu = () => {
      setClusterExpansionList([]);
      onCloseSideMenu();
    }

    const handlePrefixFilterChange = (event: any) => {
      setprefixFilter(event.target.value)
    }

    const getStatusIconColor = (element: any): string => {
      if (element.options['data-original'].status === 'ACTIVE' || element.options['data-original'].status === 'LEADER') {
        return 'green'
      }
      if (element.options['data-original'].status === 'INACTIVE') {
        return 'grey';
      }
      if (element.options['data-original'].status === 'FAILED') {
        return 'red';
      }

      return 'black';
    }

    const populateNetworkElements = (elementList: any) => {
        const elements : any = []
        elementList.filter((element: any) => element.options['data-original'].data.id.startsWith(prefixFilter)).forEach((element: any) => {
            const styleOverride = element.options['data-original'].data.id === selectedNetworkElement ? { backgroundColor: '#ECF0FA', color: '#5074B7' } : {}
            const name = clusterType === 'xcipio' ? element.options['data-original'].data.nodeName : element.options['data-original'].data.name;
            elements.push(
              <button
                key={element.options['data-original'].data.id}
                type="button"
                title={name}
                onClick={handleSelectPoi(element)}
                style={styleOverride}
              >
                <Icon
                  style={{
                    marginLeft: '0px',
                    marginRight: '6px',
                    color: getStatusIconColor(element)
                  }}
                  icon="symbol-circle"
                />
                {element.options['data-original'].status === 'LEADER' && (
                  <Tag round minimal className="master-admf-tag">
                    MASTER
                  </Tag>
                )}
                <span
                  style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textAlign: 'left'
                  }}
                >
                  {name}
                </span>
              </button>
            );
        });
        return elements;
      }
      const clusterType = clusterExpansionList[0].options['data-original'].type
    return (
      <div className="cluster-bar-container">
        <div className="top-bar">
          <div className="marker-icon-container">
            <img src={clusterType === 'af' ? AFIcon : clusterType === 'cf' ? CFIcon : XCluster} alt="networkelementicon" />
          </div>
          <h3>{clusterType === 'af' ? 'POIs in the cluster' : clusterType === 'cf' ? 'CFs in the cluster' : 'Xcipio nodes in cluster'}</h3>
          <div className="flex-spacer" />
          <div className="cross">
            <Tooltip2 content="Close cluster">
              <AnchorButton minimal icon="cross" onClick={handleCloseSideMenu} />
            </Tooltip2>
          </div>
        </div>
        <div className="search-bar">
          <input type="text" name="name" placeholder="Filter by prefix" onChange={handlePrefixFilterChange} />
        </div>
        <div className="network-element-list">
          {populateNetworkElements(clusterExpansionList)}
        </div>
      </div>
    )
}

export default NetworkTopologyClusterExpansionPane;
